import React from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { CaseHeader } from "components/Homeowner/CaseForms";
import { CASE_HISTORY_LIST_VIEW } from "typeConstants/rights";

class CaseProfileDetail extends React.Component {
  constructor(props) {
    super(props);
  }
  render() {
    const { rights } = this.props;
    return (
      <div className="case-profile">
        <CaseHeader
          {... this.props}
          controlNumber={this.props.controlNumber}
          verticalDisplay={this.props.verticalDisplay}
          showHistory={rights.includes(CASE_HISTORY_LIST_VIEW)}
        />
      </div>
    );
  }
}
CaseProfileDetail.propTypes = {
  controlNumber: PropTypes.number.isRequired,
  fetchingHeader: PropTypes.bool.isRequired,
  caseHeader: PropTypes.object.isRequired,
  caseHistory: PropTypes.object.isRequired,
  updatingCaseHeader: PropTypes.bool,
  updateCaseHeader: PropTypes.func,
  getCaseHeader: PropTypes.func.isRequired,
  rights: PropTypes.array,
  verticalDisplay: PropTypes.bool,
};

const mstp = state => ({
  rights: state.user.profile.rights,
});

export default connect(mstp)(CaseProfileDetail);
